import { WorkflowPreset } from '../types';

export const viewPreset: WorkflowPreset = {
  id: 'view',
  label: 'Simple Viewer',
  toolbar: {
    hiddenButtonIds: [
      'MeasurementTools',
      'Probe',
      'Angle',
      'CobbAngle',
      'CalibrationLine',
      'AdvancedMagnify',
    ],
  },
  panels: {
    right: false,
  },
  header: {
    showPatientInfo: true,
    showReturnButton: false,
  },
  customizations: {
    'studyBrowser.hideFilterBar': true,
    'header.hideUndoRedo': true,
  },
  // Open CT studies in the Bone window preset (WW=2500, WL=480) by default.
  defaultVoi: { windowWidth: 2500, windowCenter: 480 },
};
